import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import ProfileMemberCard from "../common/ProfileMemberCard";

const RecentlyJoined = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}admin-mat/api/get-users.php`)
      .then((response) => {
        setUsers(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => {
        console.error("There was an error fetching users!", error);
      });
  }, []);

  return (
    <div className="recently-joined-container">
      <div className="content-wrapr container" style={{ padding: "0" }}>
        <div className="heading">
          <h3 className="text-center">
            Recently Joined Members –{" "}
            <span style={{ color: "#E53D5C" }}>Start Connecting Now!</span>
          </h3>
        </div>

        <div className="swiper-container">
          <Swiper
            onClick={() => navigate("/login")}
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            navigation
            autoplay={{ delay: 3000 }}
            loop={users.length > 3}
            breakpoints={{
              1024: { slidesPerView: 3.5, spaceBetween: 20 },
              768: { slidesPerView: 2.5, spaceBetween: 15 },
              500: { slidesPerView: 1, spaceBetween: 0 },
            }}
          >
            {users.map((member, index) => (
              <SwiperSlide key={member.user_id || index}>
                <ProfileMemberCard
                  member={member}
                  nestedSlider
                  onClick={() => navigate("/login")}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <style>{`
        .recently-joined-container {
          padding: 40px 0;
          background: #f8f8f8;
        }
        .recently-joined-container .heading h3 {
          margin-bottom: 28px;
          font-weight: 700;
        }
        .recently-joined-container .swiper-slide {
          height: auto;
          padding-bottom: 8px;
        }
        .recently-joined-container .member-card {
          height: 100%;
        }
      `}</style>
    </div>
  );
};

export default RecentlyJoined;
